// removed by extract-text-webpack-plugin
module.exports = {"Front":"_3S4fr","Wrapper":"_1lwXs","Outer":"_3fghr","Inner":"_1qEfN","SeatColumn":"_1CDXo","LoaderText":"_1OlwK","Nose":"_Q_J9r","Cockpit":"_3JNmU"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Addons/Seats/SeatsMap/SeatsMap.scss
// module id = 588
// module chunks = 0